// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"9fda3646","602":"e2881eaf"}[chunkId] + ".chunk.js";
};